// Textos de una salida controlable (un circuito de un equipo actuador), compartidos por el panel del equipo y por las
// automatizaciones que la manejan.
export const STATE_LABELS = { ON: "Encendido", OFF: "Apagado" };
export const SOURCE_LABELS = { control: "el control", manual: "control manual", rule: "una regla", safety: "seguridad" };
export const LOCKOUT_REASONS = {
    overcurrent: "sobrecorriente",
    mismatch: "el equipo no obedeció varias órdenes seguidas",
};
export const FAIL_SAFE_LABELS = { OFF: "Apagar", ON: "Encender" };

export const stateLabel = (state) => STATE_LABELS[state] || "Sin definir";

export const clock = (time) => (time ? new Date(time).toLocaleTimeString("es-CL", { hour: "2-digit", minute: "2-digit", hour12: false }) : "-");

// Los errores de validación del backend llegan como { errors: [...] } o { error: "..." }.
export const errorMessage = (error, fallback) => {
    const errors = error?.response?.data?.errors;
    if (Array.isArray(errors) && errors.length) return errors.join(". ");
    return error?.response?.data?.error || fallback;
};
